"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classNames = require("classnames");
const isTemplateString = (classes) => {
    return Array.isArray(classes) && classes.hasOwnProperty('raw');
};
exports.processClasses = (classes, props, templateStringPlaceholders = []) => {
    if (isTemplateString(classes)) {
        return processAsTemplateString(classes, props, templateStringPlaceholders);
    }
    if (typeof classes === 'function') {
        return exports.processClasses(classes(props), props);
    }
    if (Array.isArray(classes)) {
        return classes.map(classesValue => exports.processClasses(classesValue, props));
    }
    return classes;
};
const preparePlaceholders = (templateStringPlaceholders, props) => {
    return templateStringPlaceholders.map(placeholder => {
        return classNames(exports.processClasses(placeholder, props));
    });
};
const compileClassnames = (placeholders, classes) => {
    const className = placeholders.reduce((acc, placeholder, i) => acc + classes[i] + placeholder, '');
    return (className + classes[classes.length - 1]).replace(/\s+/g, ' ').trim();
};
const processAsTemplateString = (classes, props, templateStringPlaceholders) => {
    const placeholders = preparePlaceholders(templateStringPlaceholders, props);
    return compileClassnames(placeholders, classes);
};
